if (!customElements.get('klevu-search')) {
  customElements.define(
    'klevu-search',
    class KlevuSearch extends window.BAO.CustomElement() {
      CLASSES = {
        listView: 'lyt-Site-searchListView',
      }

      constructor () {
        super()

        this.setDefaultView()

        this.chooseListView = this.chooseListView.bind(this)

        if (this.els?.list.exists) {
          this.els.list.elements.forEach(listEl => {
            this.listeners.add(listEl, 'click', this.chooseListView)
          })
        }

        this.chooseGridView = this.chooseGridView.bind(this)

        if (this.els?.grid.exists) {
          this.els.grid.elements.forEach(gridEl => {
            this.listeners.add(gridEl, 'click', this.chooseGridView)
          })
        }
      }

      setDefaultView () {
        if (window.localStorage.getItem(this.listViewStorageName) !== null) {
          document.body.classList.add(this.CLASSES.listView)
        }
      }

      chooseListView () {
        document.body.classList.add(this.CLASSES.listView)
        window.localStorage.setItem(this.listViewStorageName, true)
      }

      chooseGridView () {
        document.body.classList.remove(this.CLASSES.listView)
        window.localStorage.removeItem(this.listViewStorageName)
      }

      get listViewStorageName () {
        return `list-view`
      }
    },
  )
}
